import React from 'react';
import './TaskDetails.css';
import { getTasks } from './List';
import { renderList } from './filter';

var selectedTask;

function closePopup() {
    document.getElementById("opacity-layer2").style.display = "none";
    document.getElementById("task-details-popup").style.display = "none";
    selectedTask = null;
}

export function setTask(task){
    // update task details
    selectedTask = task;
    document.getElementById("task-details-name").value = task.name;
    document.getElementById("task-details-description").value = task.description;
    document.getElementById("task-details-date").value = task.date;
    // convert time to 24 hour format
    var time = task.time.split(' ');
    if (time[1] === "PM") {
        time[0] = time[0].split(':');
        time[0][0] = parseInt(time[0][0]) + 12;
        time[0] = time[0][0] + ":" + time[0][1];
        task.time = time[0];
    }else{
        task.time = time[0];
    }

    document.getElementById("task-details-time").value = task.time;
    document.getElementById("task-details-location").value = task.location;
    document.getElementById("task-details-id").innerHTML = task.id;
    document.getElementById("task-details-category").value = task.category;
    document.getElementById("details-category-color").style.backgroundColor = task.categoryColor;
    document.getElementById("opacity-layer2").style.display = "block";
    document.getElementById("task-details-popup").style.display = "block";
}

export function updateTask(){
    var tasks = getTasks();
    var i;
    for (i = 0; i < tasks.length; i++){
        if (tasks[i].id === selectedTask.id){
            break;
        }
    }
    var categories ={
        "Personal": "E5534B",
        "School": "CC6B2C",
        "Work": "46954A",
        "Other": "C96198",
        "None": "3A3D44"
    }

    var time = document.getElementById("task-details-time").value.split(':');
    var timeString = time[0] + ":" + time[1] + " AM";
    if (time[0] > 12) {
        time[0] = time[0] - 12;
        timeString = time[0] + ":" + time[1] + " PM";
    }
    // update task in local storage
    tasks[i].name = document.getElementById("task-details-name").value;
    tasks[i].description = document.getElementById("task-details-description").value;
    tasks[i].date = document.getElementById("task-details-date").value;
    tasks[i].time = timeString;
    tasks[i].location = document.getElementById("task-details-location").value;
    tasks[i].category = document.getElementById("task-details-category").value;
    tasks[i].categoryColor = "#" + categories[tasks[i].category];
    localStorage.setItem('tasks', JSON.stringify(tasks));
    closePopup();
    // refresh page
    selectedTask = null;
    renderList();
    
}

export function deleteTask(){
    var tasks = getTasks();
    var i;
    for (i = 0; i < tasks.length; i++){
        if (tasks[i].id === selectedTask.id){
            break;
        }
    }
    // delete task from local storage
    tasks.splice(i, 1);
    localStorage.setItem('tasks', JSON.stringify(tasks));
    closePopup();
    // refresh page
    selectedTask = null;
    renderList();
}

class TaskDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            category: "3A3D44",
            render: false
        };
    }

    updateCategory = () => {
        var category = document.getElementById("task-details-category").value;
        console.log(category);
        var categories ={
            "Personal": "E5534B",
            "School": "CC6B2C",
            "Work": "46954A",
            "Other": "C96198",
            "None": "3A3D44"
        }
        document.getElementById("details-category-color").style.backgroundColor = "#" + categories[category];
        this.setState({category: categories[category]});
    }

    render() {
        return (
            <div>
                <div id="opacity-layer2" onClick={closePopup} ></div>
                <div id="task-details-popup">
                    <h3 className='form-title'>Edit Task</h3>
                    <i id="task-details-id" style={{display: "none"}}></i>
                    <div className="form-group">
                        <label htmlFor="task-name">Task Name</label>
                        <input type="text" className="form-control" id="task-details-name" placeholder="Enter task name" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="task-description">Task Description</label>
                        <textarea className="form-control" id="task-details-description" rows="3"></textarea>
                    </div>
                    <div className="form-group">
                        <label htmlFor="task-date">Task Date</label>
                        <input type="date" className="form-control" id="task-details-date" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="task-time">Task Time</label>
                        <input type="time" className="form-control" id="task-details-time" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="task-location">Task Location</label>
                        <input type="location" className="form-control" id="task-details-location" />
                    </div>
                    <div className="form-group">
                            <label htmlFor="task-category">Task Category</label>
                            <div id="select-category">
                                <div id="details-category-color" style={{backgroundColor: "#" + this.state.category}}></div> 
                                <select className="form-control" id="task-details-category" onChange={() => this.updateCategory()}>
                                    <option value="None" >None</option>
                                    <option value="Work" >Work</option>
                                    <option value="Personal" >Personal</option>
                                    <option value="School" >School</option>
                                    <option value="Other" >Other</option>
                                </select>
                            </div>
                        </div>
                    <div className="task-details-buttons">
                        <button type="button" className="close-popup" onClick={closePopup} >🚫 Close</button>
                        <button type="submit" className="submit-task" onClick={updateTask} >✔️ Done</button>
                        <button type="button" className="delete-task" onClick={deleteTask}>🗑️ Delete</button>
                    </div>
                </div>
            </div>
        );
    }
}
export default TaskDetails;